// extracted by mini-css-extract-plugin
export var background = "bq_x";
export var backgroundContainer = "bq_fw";
export var buttons = "bq_cr";
export var container = "bq_h";
export var middleWave = "bq_cS";
export var section = "bq_b";
export var text = "bq_cn";
export var textContainer = "bq_bZ";
export var title = "bq_f";